import {
  GoogleAuthActionTypes,
  GoogleAuthAction,
  AuthState,
} from '../../types/googleAuth'

const initialState = {
  authData: {},
  inProgress: false,
  error: null,
  authorized: false,
  isProgress: '',
  notify: false,
}
const googleAuthReducer = (
  state = initialState,
  action: GoogleAuthAction
): AuthState => {
  switch (action.type) {
    case GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_REQUEST:
      return {
        ...state,
        inProgress: true,
      }
    case GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_SUCCESS:
      return {
        ...state,
        authData: action.payload,
        inProgress: false,
      }
    case GoogleAuthActionTypes.GET_GOOGLE_AUTH_DATA_ERROR:
      return {
        ...state,
        error: action.error.result,
        inProgress: false,
        isProgress: '',
        notify: true,
      }
    case GoogleAuthActionTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        notify: false,
      }
    case GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_REQUEST:
      return {
        ...state,
        authorized: false,
      }
    case GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_SUCCESS:
      return {
        ...state,
        authorized: true,
      }
    case GoogleAuthActionTypes.VERIFY_AUTHORIZATION_VALUE_ERROR:
      return {
        ...state,
        authorized: false,
        error: action.error,
        notify: true,
      }
    case GoogleAuthActionTypes.GET_PASSWORD_CHANGE_REQUEST:
      return {
        ...state,
      }
    case GoogleAuthActionTypes.GET_PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
      }
    case GoogleAuthActionTypes.GET_PASSWORD_CHANGE_ERROR:
      return {
        ...state,
      }

    case GoogleAuthActionTypes.VERIFY_CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
      }
    case GoogleAuthActionTypes.VERIFY_PASSWORD_CHANGE_SUCCESS:
      return {
        ...state,
      }
    case GoogleAuthActionTypes.VERIFY_CHANGE_PASSWORD_ERROR:
      return {
        ...state,
        authorized: false,
      }
    default:
      return state
  }
}
export default googleAuthReducer
